<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/demandHome/demandOrder' }">我的订单</el-breadcrumb-item>
			  <el-breadcrumb-item>订单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="container">
			<div class="leftsidebar">
				<div class="leftsidebarTitle">
					<h3>{{datails.demand.name}}</h3>
					<p>订单编号：{{datails.order_sn}}</p>
				</div>
				<div class="leftsidebarDox">
					<div class="leftsidebarDox1">
						<h3>需求方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.demandUser.avatar" alt="" srcset="" />
							<div>{{datails.demandUser.nickname}}</div>
						</div>
					</div>
					<div class="leftsidebarDox2">
						<h3>订单金额</h3>
						<div>
							￥{{datails.total_price}}
						</div>
					</div>
					<div class="leftsidebarDox1">
						<h3>服务方</h3>
						<div class="leftsidebarDox1_1">
							<img :src="datails.serveUser.avatar" alt="" srcset="" />
							<div>{{datails.serveUser.nickname}}</div>
						</div>
					</div>
				</div>
				<div class="leftsidebarTitle"  v-if="datails.status==-1 || datails.status==-2">
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
					    <el-descriptions-item label="支付时间">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
						<el-descriptions-item label="取消时间" v-if="datails.status==-1">
						         {{datails.cancel_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="支付方式">
							<span v-if="datails.pay_type=='JSAPI'">微信支付</span>
							<span v-if="datails.pay_type=='NATIVE'">扫码支付</span>
						</el-descriptions-item>
					    <el-descriptions-item label="退款时间" v-if="datails.status==-2">
							{{datails.refund_time*1000 | dateFormat}}
						</el-descriptions-item>
						<el-descriptions-item label="订单退款金额">￥{{datails.total_price}}</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton" v-if="datails.status == -2 &&  datails.message_count>0">
						<div @click="liuyan(datails.o_id,datails.status)">查看留言</div>
					</div>
				</div>
				<div class="leftsidebarTitle"  v-if="datails.status==0">
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div>立即支付</div>
					</div>
				</div>
				<div class="leftsidebarTitle"  v-if="datails.status==1 || datails.status==2 || datails.status==3 || datails.status==4 || datails.status==5">
					<el-descriptions title="订单信息">
					    <el-descriptions-item label="中标时间">{{datails.create_time}}</el-descriptions-item>
						<el-descriptions-item label="支付方式">
							<span v-if="datails.pay_type=='JSAPI'">微信支付</span>
							<span v-if="datails.pay_type=='NATIVE'">扫码支付</span>
						</el-descriptions-item>
						<el-descriptions-item label="支付时间">{{datails.pay_time*1000 | dateFormat}}</el-descriptions-item>
						<el-descriptions-item label="承认图验收时间" 
						    v-if="datails.status==3 || datails.status==4 || datails.status==5">
							{{datails.stageOne.confirm_time*1000 | dateFormat}}
						</el-descriptions-item>
						<el-descriptions-item label="生产图验收时间" 
						     v-if="datails.status==5 && datails.stageTwo.confirm_time>0">
							{{datails.stageTwo.confirm_time*1000 | dateFormat}}
						</el-descriptions-item>
						
						<el-descriptions-item label="生产图验收状态"
						     v-if="datails.status==5 && datails.stageTwo.status==-2">
							 已退款
						</el-descriptions-item>
						<el-descriptions-item label="生产图退款金额"
						     v-if="datails.status==5 && datails.stageTwo.status==-2">
							￥{{datails.stageTwo.refund_price}}
						</el-descriptions-item>
						<el-descriptions-item label="生产图退款时间"
						     v-if="datails.status==5 && datails.stageTwo.status==-2">
							{{datails.stageTwo.refund_time*1000 | dateFormat}}
						</el-descriptions-item>
					</el-descriptions>
					<!-- 承认图 未发起评审 -->
					<div class="leftsidebarButton" v-if="datails.status==2  && !datails.stageOne.review">
						<div>发起评审</div>
						<div>确认验收</div>
						<div @click="liuyan(datails.o_id,datails.status)">留言</div>
					</div>
					<!-- 承认图 已发起评审 -->
					<div class="leftsidebarButton" v-if="datails.status==2  && datails.stageOne.review">
						<div @click="liuyan(datails.o_id,datails.status)">留言</div>
					</div>
					<!-- 生产图待确定 承认图发起评审 -->
					<div class="leftsidebarButton" v-if="datails.status==3  && !datails.stageTwo.review">
						<div @click="liuyan(datails.o_id,datails.status)">留言</div>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==4  && !datails.stageTwo.review">
						<div>发起评审</div>
						<div>确认验收</div>
						<div @click="liuyan(datails.o_id,datails.status)">留言</div>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==4  && datails.stageTwo.review">
						<div @click="liuyan(datails.o_id,datails.status)">留言</div>
					</div>
					
					<div class="leftsidebarButton" v-if="datails.status==5  && datails.is_invoice>0 && datails.message_count>0">
						<div @click="liuyan(datails.o_id,datails.status)">查看留言</div>
						<div @click="chakana(datails.o_id)">查看开票</div>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==5  && datails.is_invoice==0 && datails.message_count>0">
						<div @click="liuyan(datails.o_id,datails.status)">查看留言</div>
						<div @click="kaipiao(datails.o_id)">开票</div>
					</div>
					<div class="leftsidebarButton" v-if="datails.status==5  && datails.is_invoice>0 && datails.message_count==0">
						<div @click="chakana(datails.o_id)">查看开票</div>
					</div>
				</div>
				
				
				<div class="leftsidebarTitle" v-if="datails.stageOne && datails.stageOne.review">
					<el-descriptions title="评审信息（承认图）">
					    <el-descriptions-item label="评审金支付时间：">
						     {{datails.stageOne.review.pay_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="评审金金额：">2026-01-23 09:06</el-descriptions-item>
					    <el-descriptions-item label="支付方式：">{{datails.stageOne.review.pay_type_text}}</el-descriptions-item>
					    <el-descriptions-item label="评审参与人数：">
						   {{datails.stageOne.review.review_num}}人
						</el-descriptions-item>
						<el-descriptions-item label="已参与评审人数：">
						   {{datails.stageOne.review.reviewed_count}}人
						</el-descriptions-item>
						<el-descriptions-item label="评审金退款金额：">
							￥{{datails.stageOne.review.refund_price}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div  @click="chakan">查看评审结果</div>
					</div>
				</div>
				
				<div class="leftsidebarTitle" v-if="datails.stageTwo && datails.stageTwo.review">
					<el-descriptions title="评审信息（生产图）">
					    <el-descriptions-item label="评审金支付时间：">
						    {{datails.stageTwo.review.pay_time*1000 | dateFormat}}
						</el-descriptions-item>
					    <el-descriptions-item label="评审金金额：">
							￥{{datails.stageTwo.review.total_price}}
						</el-descriptions-item>
					    <el-descriptions-item label="支付方式：">{{datails.stageTwo.review.pay_type_text}}</el-descriptions-item>
					    <el-descriptions-item label="评审参与人数：">{{datails.stageTwo.review.review_num}}人</el-descriptions-item>
						<el-descriptions-item label="已参与评审人数：">
						  {{datails.stageTwo.review.reviewed_count}}人
						</el-descriptions-item>
						<el-descriptions-item label="评审金退款金额：">
						  ￥{{datails.stageTwo.review.refund_price}}
						</el-descriptions-item>
					</el-descriptions>
					<div class="leftsidebarButton">
						<div @click="chakan">查看评审结果</div>
					</div>
				</div>
				
				
			</div>
			<div class="rightsidebar">
				<div class="rightsidebar1" v-if="datails.status==1">
					<h3>待上传承认图</h3>
					<p>交付剩余时间：<CountDown :endTime="datails.stageOne.upload_countdown*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==-1">
					<h3>已取消</h3>
					<p>订单已取消，您可查看其他订单</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==-2">
					<h3>已退款</h3>
					<p>支付金额原路退回</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==0">
					<h3>待支付</h3>
					<p>剩余支付时间：<CountDown :endTime="datails.auto_cancel_time*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==2 && !datails.stageOne.review">
					<h3>承认图待验收</h3>
					<p>剩余自动确认时间：<CountDown :endTime="datails.stageOne.auto_confirm_time*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==2 && datails.stageOne.review">
					<h3>承认图待验收</h3>
					<p>评审中，请您耐心等待</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==3 && !datails.stageOne.review">
					<h3>承认图待验收</h3>
					<p>剩余自动确认时间：<CountDown :endTime="datails.stageTwo.auto_confirm_time*1000"></CountDown></p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==3 && datails.stageOne.review">
					<h3>承认图待验收</h3>
					<p>评审中，请您耐心等待</p>
				</div>
				<div class="rightsidebar1" v-if="datails.status==5">
					<h3>已完成</h3>
					<p>感谢您使用本平台</p>
				</div>
				<div class="rightsidebar2">
					<div class="rightsidebarTitle">附件</div>
					<div class="rightsidebarbox">
						<div class="rightsidebarbox1">
							<div v-for='(i,index) in nametype' :key="index" 
								 :class="{'ait':index==typeindex}" @click="qiehuan(index)">
								 {{i.name}}
							 </div>
						</div>
					</div>
					<div class="rightsidebarImgbox">
						<rightsidebarImg :list="sidebarImg" :lexing="typeindex"></rightsidebarImg>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="开票"
		  :visible.sync="centerDialogVisible"
		  :close-on-click-modal="false"
		  width="430px"
		  >
		  <div>
			  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				  <el-form-item label="公司信息" prop="company_name">
					<el-input v-model="ruleForm.company_name"></el-input>
				  </el-form-item>
				  <el-form-item label="公司税号" prop="tax_id">
					<el-input v-model="ruleForm.tax_id"></el-input>
				  </el-form-item>
				  <el-form-item label="发票金额">
				  	 <el-input v-model="invoice_price" disabled></el-input>
				  </el-form-item>
				  <el-form-item label="邮箱信息" prop="email">
				  	<el-input v-model="ruleForm.email"></el-input>
				  </el-form-item>
				</el-form>
		  </div>
		  <span slot="footer" class="dialog-footer" style="display:flex;justify-content:center;">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import { 
		OrderDetail,
		invoicePrice,
		InvoiceApply,
		personal
	} from "@/api/api.js"
	import rightsidebarImg from '@/common/rightsidebarImg.vue'
	import CountDown from '@/common/CountDown.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg, 
		CountDown
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			typeindex:0,
			datails:"",
			rateValue:"",
			readonly:false,
			sidebarImg:[],
			invoice_price:"",
			centerDialogVisible:false,
			ruleForm:{
			   company_name: '',
			   tax_id:'',
			   email:"",
			},
			oId:"",
			user:"",
			rules: {
				 company_name: [
				   { required: true, message: '请输入公司信息', trigger: 'blur' },
				 ],
				 tax_id: [
				   { required: true, message: '请输入公司税号', trigger: 'blur' }
				 ],
				 email: [
				   { required: true, message: '邮件不能为空', trigger: 'blur' }
				 ],
			}
	    }
	  },
	  computed: {
			oid() {
			  return this.$route.query.oid || ''
			}
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		chakan(){
			const targetPath = '/demandHome/demandOrder/Reviewdatails?oid='+this.oid
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		liuyan(o_id, status) {
			if (this.$route.path !== '/demandHome/demandOrder/AddMessage') {
				this.$router.push({
					path: '/demandHome/demandOrder/AddMessage',
					query: {
						oid: o_id,
						status: status
					}
				})
			}
		},
		kaipiao(e){
			this.oId=e
			this.getpersonal()
			this.getinvoicePrice()
			this.centerDialogVisible=true  
		},
		// 查看开票
		chakana(e){
			const targetPath = '/demandHome/demandOrder/orderInvoice?oid='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		getinvoicePrice(){
		  	invoicePrice(this.oId,{}).then(res=>{
		  		this.invoice_price=res.data.data.invoice_price
		  	})
		},
		// 添加开票
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
				console.log(valid)
				if (valid) {
					this.submit()
				} else {
					return false;
				}
			});
		},
		submit(){
			InvoiceApply(this.oId,{
				...this.ruleForm
			}).then(res=>{
				if(res.data.status==200){
					this.$message.success('提交成功');
					this.centerDialogVisible=false  
					this.getdatails()
				}else{
					this.$message.success(res.data.msg);
				}
			})  
		},
		getpersonal(){
			personal({}).then(res=>{
				this.user=res.data.data
				this.ruleForm.company_name=this.user.company_name
				this.ruleForm.tax_id=this.user.tax_id
				this.ruleForm.email=this.user.email
			})
		},
		getdatails(){
			OrderDetail(this.oid,{}).then(res=>{
				this.datails=res.data.data
				const stageOneFiles = (res.data.data && res.data.data.stageOne && res.data.data.stageOne.files) || []
				this.sidebarImg = Array.isArray(stageOneFiles) ? stageOneFiles : []
				if(parseInt(this.datails.demand_score)>0){
					this.rateValue=parseInt(this.datails.demand_score)
					this.readonly=true
				}
			})
		},
		qiehuan(index){
			this.sidebarImg=[]
			this.typeindex=index
			if(this.typeindex==0){
				const stageOneFiles = (this.datails && this.datails.stageOne && this.datails.stageOne.files) || []
				this.sidebarImg = Array.isArray(stageOneFiles) ? stageOneFiles : []
			}else{
				const stageTwoFiles = (this.datails && this.datails.stageTwo && this.datails.stageTwo.files) || []
				this.sidebarImg = Array.isArray(stageTwoFiles) ? stageTwoFiles : []
			}
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.container{
		width:1200px;
		margin: 0 auto;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebar{
		width:790px;
	}
	.rightsidebar{
		width:384px;
	}
	.leftsidebarTitle{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.leftsidebarTitle span{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.leftsidebarDox{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebarDox1 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox1_1{
		width:200px;
		display:flex;
		align-items: center;
		margin-top:12px;
	}
	.leftsidebarDox1_1 img{
		width: 32px;
		height: 32px;
		margin-right:12px;
		border-radius:50%;
	}
	.leftsidebarDox1_1 div{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
	}
	.leftsidebarDox2 h3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.leftsidebarDox2 div{
		font-weight: bold;
		font-size: 24px;
		color: #FF5900;
		margin-top:15px;
	}
	.rightsidebar1{
		width:100%;
		height: 108px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		display:flex;
		justify-content:center;
		flex-wrap:wrap;
		flex-direction: column;
		text-align:center;
		margin-bottom:24px;
	}
	.rightsidebar1 h3{
		text-align:center;
		width:100%;
	}
	.rightsidebar1 p{
		color:#FF5900;
	}
	.rightsidebar2{
		width:100%;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.rightsidebarbox{
		width:100%;
		display:flex;
		align-items: center;
		justify-content:center;
		margin-top:12px;
	}
	.rightsidebarbox1{
		width: 220px;
		height: 46px;
		background: #1E3A8A;
		border-radius: 26px 26px 26px 26px;
		border: 1px solid #FFFFFF;
		opacity: 0.6;
		padding:7px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.rightsidebarbox1 div{
		width:94px;
		height:32px;
		line-height:32px;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		display: flex;
		text-align: center;
		justify-content: center;
		cursor:pointer;
	}
	.ait{
		background: #FFFFFF;
		border-radius: 16px;
		border: 1px solid #1E3A8A;
		color: #1E3A8A !important;
	}
	.rightsidebarAdd{
		width:100%;
		height: 44px;
		background: #FFFFFF;
		display:flex;
		justify-content: center;
		align-items: center;
		border:1px dashed  #1E3A8A;
		border-radius:8px;
		margin-top:12px;
		cursor:pointer;
	}
	.rightsidebarAdd img{
		width:16px;
		height:16px;
		margin-right:5px;
	}
	.rightsidebarAdd span{
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
	}
	.rightsidebarImgbox p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		margin-top:12px;
	}
	.leftsidebarButton{
		width:100%;
		display:flex;
		align-items:center;
		justify-content:flex-end;
		margin-top:30px;
	}
	.leftsidebarButton div{
		padding:5px 15px;
		box-sizing: border-box;
		background: rgba(30,58,138,0.15);
		border-radius: 8px;
		display:flex;
		justify-content:center;
		align-items: center;
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
		margin-left:10px;
		cursor: pointer;
	}
</style>